import { DocumentData } from "@/common/types/document";
import { ContactData } from "../types/publicCompanyLead";
import { PublicCompanyLeadsFunnelUpdateContactValidationSchema } from "../schemas/update.schema";
import { dateTransformer } from "@/common/utils/dateTransformer";
import { formatCpf } from "@/common/utils/formatters";

export const leadContactDocumentsDefaultValues = (documentOptions?: DocumentData[], contactDocuments?: ContactData['documents']) => {
  return documentOptions?.map((docOption) => {
    const contactDocument = contactDocuments?.find((contactDocument) => contactDocument.type === docOption.name);

    if(!contactDocument?.id) {
      return {
        doc_options: docOption,
        type: docOption.name,
      }
    }

    return {
      id: contactDocument?.id || undefined,
      type: docOption.name,
      file: contactDocument?.file || undefined,
      last_review: contactDocument?.last_review || undefined,
      ...(contactDocument?.cpf ? { cpf: formatCpf(contactDocument.cpf) } : {}),
      ...(contactDocument?.cnh ? { cnh: contactDocument.cnh } : {}),
      rg: contactDocument?.rg || undefined,
      issued_on_date:
        contactDocument?.issued_on_date
          ? contactDocument.issued_on_date.match(/\d{1,2}\/\d{1,2}\/\d{2,4}/) ? contactDocument.issued_on_date : dateTransformer(contactDocument?.issued_on_date)
          : undefined,
      ...(contactDocument?.expires_at
        ? {
            expires_at: contactDocument.expires_at.match(/\d{1,2}\/\d{1,2}\/\d{2,4}/)
              ? contactDocument.expires_at
              : dateTransformer(contactDocument?.expires_at),
          }
        : {}),
      doc_options: docOption,
      checked: !!contactDocument?.id,
    } as PublicCompanyLeadsFunnelUpdateContactValidationSchema['contacts']['documents'][0];
  });
};
